import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { usePricingConfigStore } from "@/stores/usePricingConfigStore";
import MachineConfigTab from "./MachineConfigTab";
import ProcessConfigTab from "./ProcessConfigTab";
import WastageConfigTab from "./WastageConfigTab";
import BoxPresetConfigTab from "./BoxPresetConfigTab";

const PricingConfigView = () => {
  const { activeTab, setActiveTab } = usePricingConfigStore();

  return (
    // Trang cấu hình: không tiêu đề trong trang (tiêu đề ngắn đã ở thanh header)
    <div className="p-3 md:p-4 h-full overflow-auto">
      <Tabs
        value={activeTab}
        onValueChange={(val) => setActiveTab(val as any)}
        className="space-y-4"
      >
        <TabsList>
          <TabsTrigger value="machines">Máy in Offset</TabsTrigger>
          <TabsTrigger value="processes">Công đoạn gia công</TabsTrigger>
          <TabsTrigger value="wastage">Tỷ lệ bù hao</TabsTrigger>
          <TabsTrigger value="box-presets">Mẫu hộp ECMA/FEFCO</TabsTrigger>
        </TabsList>

        <TabsContent value="machines" className="space-y-4">
          <MachineConfigTab />
        </TabsContent>

        <TabsContent value="processes" className="space-y-4">
          <ProcessConfigTab />
        </TabsContent>

        <TabsContent value="wastage" className="space-y-4">
          <WastageConfigTab />
        </TabsContent>

        <TabsContent value="box-presets" className="space-y-4">
          <BoxPresetConfigTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PricingConfigView;
